<script setup lang="ts" generic="T extends Record<string, any>">
const props = defineProps<{ items: T }>();
</script>

<template>
    <SectionsBase class="pt-0! flex-center flex-col gap-8">
        <div
            v-for="feature in props.items"
            :key="feature.title"
            class="relative w-full flex-center flex-col gap-6 pt-80 overflow-hidden before:content-[''] before:absolute before:w-full
                before:aspect-square before:bg-linear-to-b before:from-primary-50 before:to-transparent before:top-0
                after:content-[''] after:absolute after:h-full after:w-full after:bg-linear-to-b after:from-primary-50
                after:to-white after:to-60% after:mt-70 after:z-2 after:blur-lg"
        >
            <div 
                class="absolute w-50 flex-center top-8"
                data-aos="fade-up" 
                data-aos-duration="1000"
            >
                <IconsMobile class="absolute w-50 z-1 top-0" />
                <img
                    :src="feature?.img"
                    :alt="feature?.title"
                    width="200"
                    loading="lazy"
                    class="rounded-4xl w-47 absolute top-0"
                />
            </div>
            <div class="w-full flex-center flex-col gap-6 relative z-5 container pt-10">
                <div 
                    v-for="item, index in feature.items"
                    :key="item.title"
                    class="max-w-95"
                    data-aos="fade-up" 
                    data-aos-duration="1000"
                >
                    <div class="flex items-center gap-2 mb-4">
                        <Icon 
                            :name="item.icon" 
                            size="24"
                            :class="index ? 'text-teal-500' : 'text-pink-500'"
                        />
                        <h3>{{ item.title }}</h3>
                    </div>
                    <p class="text-body2 text-gray-400" v-html="item.desc" />
                </div>
            </div>
        </div>
    </SectionsBase>
</template>